import * as React from 'react';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { defaultStyle } from './Styles';
import { SxProps } from '@mui/joy/styles/types';

export interface OptionType {
  value: string | number;
  label: string;
  disabled?: boolean;
}

interface SelectProps {
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  value?: string | number | null;
  defaultValue?: number | string;
  placeholder?: string;
  options: OptionType[];
  style?: SxProps;
  onChange: (newValue: string | number | null) => void;
}

export const CustomSelect: React.FC<SelectProps> = ({
  size,
  value,
  disabled,
  style,
  defaultValue,
  placeholder,
  options,
  onChange,
}) => {
  return (
    <Select
      value={value}
      size={size}
      disabled={disabled}
      defaultValue={defaultValue}
      placeholder={placeholder}
      indicator={<KeyboardArrowDown />}
      sx={{ ...defaultStyle, ...style }}
      onChange={(_event, newValue) => onChange(newValue)}
      slotProps={{
        listbox: {
          sx: {
            position: 'fixed',
            zIndex: 9999,
          },
        },
      }}
    >
      {options.map(option => (
        <Option
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </Option>
      ))}
    </Select>
  );
};
